module.exports = __webpack_public_path__ + "static/media/en-flag.87e99861.svg";